module.exports = __webpack_public_path__ + "static/media/icon-eye-blue-fill.ffe4ce0e.svg";